const Account = () => import(/* webpackChunkName: "account" */ '../views/Account')
const AccountProfile = () => import(/* webpackChunkName: "account" */ '../views/Account/AccountProfile')
const AccountProfileEdit = () => import(/* webpackChunkName: "account" */ '../views/Account/AccountProfileEdit')
const AccountOrders = () => import(/* webpackChunkName: "account" */ '../views/Account/AccountOrders')
const AccountPasswordEdit = () => import(/* webpackChunkName: "account" */ '../views/Account/AccountPasswordEdit')

export default [{
  path: 'account',
  name: 'account',
  component: Account,
  redirect: {
    name: 'account-profile',
  },
  meta: {
    requiresAuth: true
  },
  children: [
    {
      path: 'profile',
      name: 'account-profile',
      component: AccountProfile,
    },
    {
      path: 'profile/edit-profile',
      name: 'account-profile-edit',
      component: AccountProfileEdit
    },
    {
      path: 'orders',
      name: 'account-orders',
      component: AccountOrders
    },
    {
      path: 'edit-password',
      name: 'account-password-edit',
      component: AccountPasswordEdit
    }
  ]
}]
